/**
 * ContentFooterSlot - Renders controls in the content-footer location.
 *
 * This slot appears below the main content area and is typically used for
 * controls that don't need to be visible while browsing (like axis range controls).
 */

import React from 'react';

import {MediaBrowserPanelProps, MediaConfigWithDefaults} from '../../Component';
import {StepMeta} from '../../types';
import {GridData, SlotRegistry} from '../types';
import {ControlRenderer} from './ControlRenderer';

export type ContentFooterSlotProps = {
  controls: NonNullable<SlotRegistry[keyof SlotRegistry]>;
  config: MediaConfigWithDefaults;
  updateConfig: MediaBrowserPanelProps['updateConfig'];
  stepMeta: StepMeta;
  currentStep: number;
  mediaIndex: number;
  isMaxStepLoading: boolean;
  mediaBrowserSize: {width: number; height: number};
  gridData: GridData;
  columnCount: number;
};

/**
 * Renders controls in the content-footer location.
 *
 * @param props - Content footer slot props
 * @returns Rendered controls in footer layout
 */
export const ContentFooterSlot: React.FC<ContentFooterSlotProps> = ({
  controls,
  config,
  updateConfig,
  stepMeta,
  currentStep,
  mediaIndex,
  isMaxStepLoading,
  mediaBrowserSize,
  gridData,
  columnCount,
}) => {
  return (
    <div className="control-popup__container">
      <div className="control-popup__slider-container control-popup__item">
        {controls.map((control, idx) => (
          <ControlRenderer
            key={`footer-control-${idx}`}
            control={control}
            index={idx}
            config={config}
            updateConfig={updateConfig}
            stepMeta={stepMeta}
            currentStep={currentStep}
            mediaIndex={mediaIndex}
            additionalProps={{
              isMaxStepLoading,
              mediaBrowserSize,
              gridData,
              columnCount,
            }}
          />
        ))}
      </div>
    </div>
  );
};
